var render, staticRenderFns
import script from "./associated_customer_three_replace_position.vue?vue&type=script&lang=js"
export * from "./associated_customer_three_replace_position.vue?vue&type=script&lang=js"
import style0 from "./associated_customer_three_replace_position.vue?vue&type=style&index=0&id=1bc82b6c&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc82b6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bc82b6c')) {
      api.createRecord('1bc82b6c', component.options)
    } else {
      api.reload('1bc82b6c', component.options)
    }
    
  }
}
component.options.__file = "found/views/mdm/views/user_client_management/form/associated_customer/associated_customer_three_replace_position.vue"
export default component.exports